export default (params) => `
  <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="http://webservice/">
    <soapenv:Header/>
    <soapenv:Body>
      <web:getRemittanceStatus>
        <remittancTrackingCode>${params.remittancTrackingCode}</remittancTrackingCode>
        <userId>${params.userId}</userId>
        <userKey>${params.userKey}</userKey>
      </web:getRemittanceStatus>
    </soapenv:Body>
  </soapenv:Envelope>
`